import { COBStep, getCommonReachableSteps } from '../ClientOnboarding.common.utils';
export function getVendorGradientStyle(branding) {
    return {
        background: "linear-gradient(315deg, var(--bg-gradient-color-2, ".concat(branding.backgroundGradientEnd, ") 0%, var(--bg-gradient-color-1, ").concat(branding.backgroundGradientStart, ") 100%)")
    };
}
export function getReachableInnerSteps(relationship) {
    return [
        COBStep.introduction,
        ...getCommonReachableSteps(relationship),
        COBStep.signAndApprove,
        COBStep.allSet
    ];
}
export function getNextStepButtonText(step, relationship) {
    const reachableSteps = getReachableInnerSteps(relationship);
    const currentStepIndex = reachableSteps.indexOf(step);
    if (currentStepIndex === -1) {
        return 'Next';
    }
    if (step === COBStep.signAndApprove) {
        return 'Approve agreement';
    }
    const nextStep = reachableSteps[currentStepIndex + 1];
    if (!nextStep) {
        return 'Approve agreement';
    }
    if (nextStep === COBStep.selectAPackage) {
        return 'Select a package';
    }
    return 'Next';
}
